/**
 * @desc WFS售后单结果导入
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/inPlanMaster/importWfsAfterSaleInResult`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
